import React from 'react';
import styled from 'styled-components';
import { AvInput } from 'availity-mobx-reactstrap-validation';

export default styled(AvInput)`
  display: inline;
  font-size: 1.3rem;
  font-weight: 500;
  border-bottom-right-radius: 0;
  border-bottom-left-radius: 0;
`;
